/*
 * Mesure d'audience Epic Trace — sans cookie, sans identifiant, sans tiers.
 * Un signal par page vue, puis un « toujours là » toutes les 30 s tant que l'onglet
 * est visible (pour la carte en direct de l'Atelier). Le serveur ne garde que le
 * pays, la ville, la page et une empreinte du jour — voir sso-worker/src/stats.js.
 * Le cookie « et_nostats=1 » (posé par l'Atelier à la connexion admin, domaine
 * .epic-trace.fr) coupe la balise : les visites de l'équipe ne sont pas du trafic.
 */
(function () {
  if (window.Shopify && window.Shopify.designMode) return;
  if (navigator.webdriver) return;
  if (/(?:^|;\s*)et_nostats=1(?:;|$)/.test(document.cookie)) return;
  var endpoint = 'https://sso.epic-trace.fr/stats/';
  /* Campagne (« ?utm_campaign=… » posé sur les liens des publicités) : envoyée avec la
     page vue d'arrivée seulement, pour compter les clics et suivre l'entonnoir de ces
     visiteurs dans l'Atelier. Jamais stockée côté navigateur. */
  var campaign = '';
  try {
    var m = /[?&]utm_campaign=([^&#]*)/.exec(location.search);
    if (m) campaign = decodeURIComponent(m[1].replace(/\+/g, ' ')).trim().slice(0, 64);
  } catch (e) { campaign = ''; }
  /* Liens Shopify Collabs (« epic-trace.fr/CODE » → « …?dt_id=… » + cookie discount_code) :
     sans utm_campaign, la visite est rangée sous « collabs-<code du créateur> », pour
     la distinguer des publicités. Le cookie n'est lu qu'à l'arrivée portant dt_id. */
  if (!campaign) {
    try {
      var d = /[?&]dt_id=([0-9]+)/.exec(location.search);
      if (d) {
        var c = /(?:^|;\s*)discount_code=([^;]*)/.exec(document.cookie);
        var code = c ? decodeURIComponent(c[1]).trim().toLowerCase().replace(/[^a-z0-9._-]/g, '').slice(0, 40) : '';
        campaign = 'collabs-' + (code || d[1]);
      }
    } catch (e) { /* campagne laissée vide */ }
  }
  function send(kind) {
    var body = JSON.stringify({
      site: 'shop',
      path: location.pathname,
      ref: kind === 'hit' ? document.referrer : '',
      campaign: kind === 'hit' ? campaign : ''
    });
    try {
      if (navigator.sendBeacon) navigator.sendBeacon(endpoint + kind, body);
      else fetch(endpoint + kind, { method: 'POST', body: body, keepalive: true, mode: 'no-cors' });
    } catch (e) { /* jamais bloquant */ }
  }
  send('hit');
  setInterval(function () {
    if (document.visibilityState === 'visible') send('ping');
  }, 30000);
})();
